//var $ = $.noConflict(true);
resetNewsletter(); //initialising the error message

$(document).on("click","#contact_fields_submit", function() {
  resetNewsletter();

  if(($('.omnisend-subscribe-input-email').val() == '') || !($('#subscribe-confirm').is(':checked'))){
    if(($('.omnisend-subscribe-input-email').val() == '')){
      //console.log('newsletter emeil required');
      showNewsLetterErrorMessage();
      $('.omnisend-subscribe-input-email').css('border', '1px solid red');
    }
    if(!($('#subscribe-confirm').is(':checked'))){
      //console.log('checkbox is not checked.');
      showNewsLetterErrorMessage();
      $('.subscribe-confirm-label b').css('border', '1px solid red');
    }
    return false;
  }else{
  	var email = $('.omnisend-subscribe-input-email').val();
    var lang = $('#activated_lang').val();
    var strPos = lang.indexOf(".");
    var domainLocation = lang.substr(0, strPos);
    
    console.log('domainLocation',domainLocation);
    
    $.ajax({
      url: 'https://ultrafirming.com/shopify.php',

      data: {"api":"12eac677186d67b","hash":"bbf5ee7e84883bfaf2e7f8170b45344c","email":email,"list_id":"52","lang":domainLocation},
      type: 'GET',
      dataType: "jsonp",
      crossDomain: true,
      success: function(data){},
      error: function(data){
        $('#pop-div-custom').show();
        $('.omnisend-subscribe-input-email').val("");
      }
    });
  }
});
$(document).on("click","#close_custom_modal", function() {
	$('#pop-div-custom').hide();
});
  
function validateEmail(email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test( email );
}

function resetNewsletter(){
  $('.omnisend-subscribe-input-email').css('border', '1px solid black');
  $('.subscribe-confirm-label b').css('border', '1px solid black');
  $('.soundest-form-without-image-error-empty').html(''); 
}

function showNewsLetterErrorMessage(){
  $('.soundest-form-without-image-error-empty').html('Please fill in all required form fields!').css('color','red');
}